export const SET_DEAL_WON_REASON = 'SET_DEAL_WON_REASON'
export const SET_DEAL_WON_REASON_SUBMIT = 'SET_DEAL_WON_REASON_SUBMIT'
export const SET_DEAL_WON_REASON_FAILURE = 'SET_DEAL_WON_REASON_FAILURE'
